import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { routes } from '../../routes/main';
import { ThemeProvider } from '../contexts/ThemeContext';
import { Sheet, SheetContent, SheetTitle, SheetDescription, } from '../components/ui/sheet';
const DefaultLayout = ({ children }) => {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const navItems = routes.map((route) => {
        var _a;
        return ({
            label: route.label,
            href: route.path,
            description: route.description,
            subItems: (_a = route.subItems) === null || _a === void 0 ? void 0 : _a.map((s) => ({
                label: s.label,
                href: s.path,
                description: s.description,
            })),
            hidden: route.hidden,
            sectionTitle: route.sectionTitle,
        });
    });
    return (_jsx(ThemeProvider, { defaultTheme: "light", children: _jsxs("div", { className: "h-screen w-screen flex bg-gray-50 dark:bg-gray-900 overflow-hidden", children: [_jsx("div", { className: `hidden lg:flex shrink-0 transition-[width] duration-200 ${collapsed ? 'w-14' : 'w-60'}`, children: _jsx(Sidebar, { items: navItems, isCollapsed: collapsed, onToggleCollapse: () => setCollapsed((c) => !c), className: "w-full" }) }), _jsx(Sheet, { open: mobileNavOpen, onOpenChange: setMobileNavOpen, children: _jsxs(SheetContent, { side: "left", className: "w-64 p-0 flex flex-col border-r border-gray-200 dark:border-gray-800", children: [_jsx(SheetTitle, { className: "sr-only", children: "Navigation" }), _jsx(SheetDescription, { className: "sr-only", children: "Main application navigation" }), _jsx(Sidebar, { items: navItems, isCollapsed: false, onNavigate: () => setMobileNavOpen(false), showCollapseToggle: false })] }) }), _jsxs("div", { className: "flex flex-1 flex-col min-w-0", children: [_jsx(Header, { onOpenMobileNav: () => setMobileNavOpen(true) }), _jsx("main", { className: "flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900", children: children })] })] }) }));
};
export default DefaultLayout;
